<div [formGroup]="form" class="row">
  <div class="form-group col-6" >
    <custom-select
      [filterEnabled]="true"
      [labelText]="'Tipo de recurso'"
      [bordered]="true"
      name="resourceType"
      id="resourceType"
      formControlName="resourceType"
      [(sourceList)]="_resourceTypeList"
      (select)="onSelectResource(resourceType)"
      required>
    </custom-select>
  </div>
  <div class="form-group col-6" *ngIf="resourceType?.value?.value === 1">
    <label for="movil">Móvil</label>
    <custom-select
      [filterEnabled]="true"
      [bordered]="true"
      name="asset"
      id="asset"
      formControlName="movil"
      [(sourceList)]="_movilList"
      (select)="onSelectMovil(movil?.value)"
      requerid
    ></custom-select>
  </div>
  <div class="form-group col-6"  *ngIf="resourceType?.value?.value === 2">
    <custom-select
      [filterEnabled]="true"
      [labelText]="'Servicio externo'"
      [bordered]="true"
      name="externalMovil"
      id="externalMovil"
      formControlName="externalMovil"
      [(sourceList)]="_externalMovilList"
    ></custom-select>
  </div>
  <div class="form-group col-6" *ngIf="resourceType?.value?.value === 2">
    <label for="licensePpu">PPU</label>
    <input
      type="text"
      customFocus
      name="licensePpu"
      formControlName="dispatchLicensePlate"
      class="form-control"
      id="licensePpu"
      [placeholder]="'Patente'"
    >
  </div>
  <div class="form-group col-6">
    <lib-datepicker
    [labelText]="'Despacho'"
    name="dispatchDateTime"
    id="dispatchDateTime"
    [useTime]="true"
    [initCurrentTime]="!dispatchDateTime?.value?.Date?.Day ? true : false"
    [defaultToday]="true"
    [disabledFutureDates]="true"
    formControlName="dispatchDateTime"
    (openCalendar)="updateMaxDate()"
    (ngModelChange)="applyFilters('dispatchDateTime')"
    [maxDate]="today"
    [required]="true"
    ></lib-datepicker>
  </div>
  <div class="form-group col-6">
    <label for="departureDateTime">Partida</label>
    <lib-datepicker
    name="departureDateTime"
    id="departureDateTime"
    [placeholder] ="'Fecha y hora partida'"
    [useTime]="true"
    [initCurrentTime]="!departureDateTime?.value?.Date?.Day ? true : false"
    [defaultToday]="false"
    [disabledFutureDates]="true"
    formControlName="departureDateTime"
    (openCalendar)="updateMaxDate()"
    (ngModelChange)="applyFilters('departureDateTime')"
    [minDate]="minDateDispatch"
    [maxDate]="today"
    [required]="(arrivalDateTime?.value?.Date?.Day || dateEndDateTimeDispacth?.value?.Date?.Day) ? true : false"
    ></lib-datepicker>
  </div>
  <div class="form-group col-6">
    <label for="arrivalDateTime">Llegada</label>
    <lib-datepicker
    name="arrivalDateTime"
    id="arrivalDateTime"
    [placeholder] ="'Fecha y hora llegada'"
    [useTime]="true"
    [initCurrentTime]="!arrivalDateTime?.value?.Date?.Day ? true : false"
    [defaultToday]="false"
    [disabledFutureDates]="true"
    formControlName="arrivalDateTime"
    (openCalendar)="updateMaxDate()"
    (ngModelChange)="applyFilters('arrivalDateTime')"
    [minDate]="minDateDeparture"
    [maxDate]="today"
    [required]="(dateEndDateTimeDispacth?.value?.Date?.Day) ? true : false"
    ></lib-datepicker>
  </div>
  <div class="form-group col-6">
    <label for="dateEndDateTime">Fin asistencia</label>
    <lib-datepicker
    name="dateEndDateTime"
    id="dateEndDateTime"
    [placeholder] ="'Fecha y hora fin asistencia'"
    [useTime]="true"
    [initCurrentTime]="!dateEndDateTimeDispacth?.value?.Date?.Day ? true : false"
    [defaultToday]="false"
    [disabledFutureDates]="true"
    formControlName="dateEndDateTimeDispacth"
    (openCalendar)="updateMaxDate()"
    (ngModelChange)="applyFilters('dateEndDateTimeDispacth')"
    [minDate]="minDateEndDispatch"
    [maxDate]="today"
    [required]="(dateEndDateTimeTransfer?.value?.Date?.Day) ? true : false"
    ></lib-datepicker>
  </div>
  <div class="form-group col-6">
    <label for="dateEndDateTimeTransfer">Fin traslado</label>
    <lib-datepicker
    name="dateEndDateTimeTransfer"
    id="dateEndDateTimeTransfer"
    [placeholder] ="'Fecha y hora fin traslado'"
    [useTime]="true"
    [initCurrentTime]="!dateEndDateTimeTransfer?.value?.Date?.Day ? true : false"
    [defaultToday]="false"
    [disabledFutureDates]="true"
    formControlName="dateEndDateTimeTransfer"
    (openCalendar)="updateMaxDate()"
    (ngModelChange)="applyFilters('dateEndDateTimeTransfer')"
    [minDate]="minDateEndAssistance"
    [maxDate]="today"
    [required]="false"
    ></lib-datepicker>
  </div>
  <div class="form-group col-6" *ngIf="incidentID">
    <label for="assistance">Tipo</label>
    <custom-select
      [filterEnabled]="true"
      [bordered]="true"
      name="assistance"
      id="assistance"
      formControlName="assistance"
      [(sourceList)]="_assistanceList">
    </custom-select>
  </div>
  <div class="form-group col-6">
    <label for="observation">Observación</label>
    <input
    type="text" 
    maxlength="255"
    name="observation"
    formControlName="observation"
    class="form-control" 
    id="observation" 
    [placeholder]="'Observación'"
    >
  </div>
  <div class="form-group col-6">
    <label for="identification">Identificación</label>
    <input
    type="text" 
    maxlength="50"
    name="identification"
    formControlName="identification"
    class="form-control" 
    id="identification" 
    [placeholder]="'Identificación'"
    >
  </div>
  <div class="form-group col-6">
    <label for="dispatchReference">Responsable</label>
    <input
    type="text" 
    maxlength="50"
    name="dispatchReference"
    formControlName="dispatchReference"
    class="form-control" 
    id="dispatchReference" 
    [placeholder]="'Responsable'"
    >
  </div>
</div>